/**
 * Shipment status presentation helpers
 * Shared icon, color, and label maps used by lookup results and tracking views.
 */

import {
  Package,
  Truck,
  CheckCircle2,
  Clock,
  type LucideIcon,
} from 'lucide-react';

export const SHIPMENT_STATUS_ICONS: Record<string, LucideIcon> = {
  PENDING: Clock,
  IN_TRANSIT: Truck,
  DELIVERED: CheckCircle2,
  OUT_FOR_DELIVERY: Truck,
  default: Package,
};

export const SHIPMENT_STATUS_COLORS: Record<string, string> = {
  PENDING:
    'text-yellow-600 bg-yellow-50 dark:text-yellow-400 dark:bg-yellow-900/20',
  IN_TRANSIT:
    'text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-900/20',
  DELIVERED:
    'text-green-600 bg-green-50 dark:text-green-400 dark:bg-green-900/20',
  OUT_FOR_DELIVERY:
    'text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-900/20',
  default: 'text-foreground-muted bg-background-tertiary',
};

export function getShipmentStatusIcon(status: string): LucideIcon {
  return SHIPMENT_STATUS_ICONS[status] ?? SHIPMENT_STATUS_ICONS.default;
}

export function getShipmentStatusColor(status: string): string {
  return SHIPMENT_STATUS_COLORS[status] ?? SHIPMENT_STATUS_COLORS.default;
}

const STATUS_LABEL_MAP: Record<string, string> = {
  PENDING: 'Preparing to Ship',
  IN_TRANSIT: 'In Transit',
  DELIVERED: 'Delivered',
  OUT_FOR_DELIVERY: 'Out for Delivery',
};

export function formatShipmentStatus(status: string): string {
  return (
    STATUS_LABEL_MAP[status] ||
    status
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase())
  );
}

const CARRIER_LABEL_MAP: Record<string, string> = {
  UPSDAP: 'UPS',
  UPS: 'UPS',
  USPS: 'USPS',
  FEDEX: 'FedEx',
  FEDEXDEFAULT: 'FedEx',
};

export function formatCarrier(carrier: string): string {
  return CARRIER_LABEL_MAP[carrier.toUpperCase()] || carrier;
}
